import React, { Fragment } from "react";
import PasswordModule from "../modules/PasswordModule";
import { withRouter } from "react-router-dom";

import "../components/css/Login.css";

const logo = require("../images/Logo.png");
function ResetEmailPasswordPage({ history, match }) {
  return (
    <Fragment>
      <div
        className="c-hero-teaser c-hero-teaser--auto c-hero-teaser--login"
        data-testid="resetEmailPasswordPageTestId"
      >
        <img
          className="c-hero-teaser__image"
          srcSet={
            process.env.PUBLIC_URL + "/Bronson/img/rema_mobile_background.jpg"
          }
          src={
            process.env.PUBLIC_URL + "/Bronson/img/rema_mobile_background.jpg"
          }
          sizes="100vw"
          alt="Rema Mobile Home"
        ></img>
        <div id="js-hero-teaser-content" className="c-hero-teaser__content ">
          <div className="c-hero-teaser__content-inner">
            <div className="c-hero-teaser__box u-mt-small boxLogin box-reset-password">
              <form action="#">
                <fieldset className="o-fieldset">
                  <legend className="c-form-heading">
                    <strong className="c-form-heading__title">
                      <img
                        src={String(logo)}
                        alt="Rema Mobile"
                        height="40"
                      ></img>
                    </strong>
                  </legend>
                  <PasswordModule
                    IsResetPasswordEmail={true}
                    history={history}
                  ></PasswordModule>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default withRouter(ResetEmailPasswordPage);
